import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { parse } from 'query-string';
import { func, object } from 'prop-types';
import {
  // startSetStatisticsTabs,
  setStatisticsFilters,
  resetStatFilters,
} from '../../actions/statistics';
import { Col } from 'reactstrap';
import Statistics from '../../components/Statistics/Statistics/Statistics';
import Layout from '../../components/Layout/Layout';
import WithAlert from '../../hoc/WithAlert';
import { correctFiltersIfInvalid } from '../../components/Statistics/statisticsHelpers';
import BannerWidget from '../../widgets/BannerWidget/BannerWidget';
import Icon from '../../components/Icon/Icon';

class StatisticsPage extends Component {
  static propTypes = {
    resetStatFilters: func.isRequired,
    startSetStatisticsTabs: func.isRequired,
    setStatisticsFilters: func.isRequired,
    history: object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      showBannerWidget: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.findFilters();
  }

  componentDidMount() {
    if (!localStorage.getItem('hide_statistic_banner')) this.setState({ showBannerWidget: true });
  }

  // componentDidMount() {
  //   const { startSetStatisticsTabs } = this.props;
  //   startSetStatisticsTabs();
  // }

  componentWillUnmount() {
    const { history } = this.props;
    if (!history?.location?.pathname?.includes('statistics')) this.props.resetStatFilters();
  }

  prepareFilters = (items = {}) =>
    Object.keys(items).reduce((filters, key) => {
      if (items[key]) {
        const filter = { [key]: this.normalizeValues(items[key], key) };
        return { ...filters, ...filter };
      }

      return filters;
    }, {});

  normalizeValues = (values = '', param) => {
    if (param === 'dateFrom' || param === 'dateTo') {
      return values;
    }

    const normalized = Array.isArray(values) ? values : values.split(',').filter(String);

    return normalized.map((val) => {
      if (!isNaN(val)) {
        return parseInt(val, 10);
      }

      if (param === 'countries') {
        return val.trim().toUpperCase();
      }

      return val.trim();
    });
  };

  handleCloseBannerClick = () => {
    this.setState({ showBannerWidget: false });
    localStorage.setItem('hide_statistic_banner', true);
  };

  findFilters = () => {
    const filters = parse(this.props.location.search);
    if (Object.keys(filters).length > 0) {
      const correctFilters = correctFiltersIfInvalid(filters);
      this.props.setStatisticsFilters(this.prepareFilters(correctFilters));
    }
  };

  render() {
    const { isMember, className, showAlert, resetStatFilters } = this.props;
    const { showBannerWidget } = this.state;

    return (
      <>
        {!isMember ? (
          <Layout formattedTitle="pages.statistics.title">
            <Layout.Col>
              <Statistics showAlert={showAlert} resetFilters={resetStatFilters} />
            </Layout.Col>
          </Layout>
        ) : (
          <Statistics showAlert={showAlert} className={className} isMember />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  resetStatFilters: () => dispatch(resetStatFilters()),
  // startSetStatisticsTabs: () => dispatch(startSetStatisticsTabs()),
  setStatisticsFilters: (filters) => dispatch(setStatisticsFilters(filters)),
});

export default connect(null, mapDispatchToProps)(WithAlert(StatisticsPage));
